import {
  FAQS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Hudson-valley-Renegades.png";
const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/DBH%20Pass%20Assets/HV%20Renegades/hvrenegades-order-summary-background.png";

export const hvrenegades_pass: TTeamConfig = {
  TEAM_SCHEMA: "hvrenegades_pass",
  TEAM_FULL_NAME: "Hudson Valley Renegades",
  BROWSER_TITLE: "Renegades Summer Pass",
  CLIENT_ID: "05a834d73a3f.seasonshare.hvrenegades-dbh.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#002a5b",
    COLORS_SECONDARY: "#0096d6",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#0096d6",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
